export const normalizeMetricUnitFormat = (format: string): string =>
  format.replace(/\s+%/g, '%');
